/**
 * Season Calculator API
 * Provides endpoints to calculate IATA season from dates
 */

import { baseApi } from './baseApi';

export interface SeasonInfo {
  seasonId: string;
  seasonType: 'SUMMER' | 'WINTER';
  startDate: string;
  endDate: string;
}

export const seasonCalculatorApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSeasonFromDate: builder.query<SeasonInfo, string>({
      query: (date) => ({
        url: '/season-calculator/from-date',
        params: { date },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetSeasonFromDateQuery,
  useGetSeasonFromDateQuery,
} = seasonCalculatorApi;
